// extracted by mini-css-extract-plugin
module.exports = {"controls":"CheckModal-module__controls___2kHNY","controlsWrapper":"CheckModal-module__controlsWrapper___32ITa","loader":"CheckModal-module__loader___ewW6J"};